export default defineI18nConfig(() => ({
    fallbackLocale: 'de',
    datetimeFormats: {
        'de': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
        },
        'en': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
        }
    }
}))